import React, {createContext, useEffect, useState} from "react";
import {useFetchHook} from "../../../hooks/useFetchHook";
import fetcher from "../../../fetcher";
import {LEASE_DEAL_DARK} from "../../../contexts/DeskingContext";
import {PURCHASE_DEAL_LIGHT} from "../../../contexts/DealContext";
import useDidMountEffect from "../../../hooks/useDidMountEffect";

export const PDFContext = createContext(null)

// `companyLogoUrl` reaches here through each worksheet's {...props} spread, and
// joins pageColor as a non-quote value carried on PDFContext — that keeps the
// four worksheet documents unaware of branding.
export const BasePDF = ({ dealState, initialPDFState, companyLogoUrl, children } ) => {
    const [fetchPDFResponse, fetchPDF] = useFetchHook(fetcher.getPDF)
    const [pdfState, setPDFState] = useState(initialPDFState)

    useEffect(function fetchPDFFromBE(){
        fetchPDF(dealState.id)
    }, []);

    useEffect(function setFetchedPDF(){
        if (fetchPDFResponse?.data?.data && !fetchPDFResponse.loading && !fetchPDFResponse?.error) {
            setPDFState(fetchPDFResponse?.data?.data)
        }
    }, [fetchPDFResponse])

    if (!pdfState) return null;

    const pageColor = dealState.is_purchase ? PURCHASE_DEAL_LIGHT : LEASE_DEAL_DARK

    return (
        <PDFContext.Provider value={{...pdfState, pageColor: pageColor, companyLogoUrl: companyLogoUrl}}>
            {children}
        </PDFContext.Provider>
    )
}